import MultiSearchBar from "./src/MultiSearchBar";

export default MultiSearchBar;
